import React from "react";
import { Button, ButtonGroup } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const InhWhiteContainedButtonGroup = () => {
  return (
    <>
      <PreviewAndEditor
        language="js"
        title={"Contained Inherit white button group"}
        value={
          '<ButtonGroup disableElevation={false} color={"inheritWhite"} aria-label="contained inherit white button group">\n\t<Button>One</Button>\n\t<Button>Two</Button>\n\t<Button>Three</Button>\n</ButtonGroup>'
        }
      >
        <ButtonGroup
          disableElevation={false}
          color={"inheritWhite"}
          aria-label="contained inherit white button group"
        >
          <Button>One</Button>
          <Button>Two</Button>
          <Button>Three</Button>
        </ButtonGroup>
      </PreviewAndEditor>
    </>
  );
};

export default InhWhiteContainedButtonGroup;
